import PropTypes from 'prop-types';

function IFBeveragesInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11310)">
                <path
                    d="M2.95962 5.34114L2.61652 2.94419L13.2717 1.69092L13.7483 3.80671L2.95962 5.34114Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.95969 5.3457C2.95969 5.3457 1.83031 8.91491 1.91132 10.4112C1.99233 11.9075 4.41311 28.0095 4.47029 28.3955C4.52747 28.7814 8.22058 29.8918 8.22058 29.8918C8.22058 29.8918 7.30564 14.1091 5.69497 9.27708C5.30422 8.09528 2.95969 5.3457 2.95969 5.3457Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.95966 5.34549C2.95966 5.34549 5.00397 8.20467 5.3423 9.7248C5.68064 11.2449 7.82503 29.944 8.20148 29.8915C8.57794 29.8391 19.1188 26.9371 19.1617 26.6845C19.2046 26.4319 16.8934 9.32451 16.5979 8.64308C16.3025 7.96164 13.9389 3.77771 13.7388 3.8063L2.95966 5.34549Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.97272 22.5521L9.97218 22.5522C9.86988 22.575 9.76397 22.5764 9.6611 22.5564C9.55823 22.5363 9.46063 22.4951 9.37442 22.4355C9.28821 22.3759 9.21526 22.2991 9.16014 22.21C9.10504 22.1209 9.06895 22.0213 9.05416 21.9176C9.05415 21.9175 9.05415 21.9175 9.05415 21.9175L8.47796 17.8556C8.45618 17.6701 8.50351 17.4829 8.61097 17.33C8.71883 17.1765 8.87965 17.0682 9.06248 17.0262C9.06258 17.0261 9.06268 17.0261 9.06278 17.0261L15.1522 15.6443L15.1528 15.6442C15.2568 15.6203 15.3647 15.6187 15.4694 15.6395C15.5741 15.6604 15.6731 15.7032 15.7601 15.7651C15.847 15.827 15.9198 15.9066 15.9738 15.9987C16.0277 16.0908 16.0615 16.1933 16.073 16.2994L16.073 16.2994L16.0732 16.3014L16.5497 20.4037C16.5497 20.4039 16.5497 20.404 16.5497 20.4041C16.5709 20.5908 16.5221 20.7787 16.4129 20.9316C16.3037 21.0846 16.1416 21.1916 15.958 21.2321L15.9579 21.2321L9.97272 22.5521Z"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                />
                <path
                    d="M22.0955 21.5475L25.3477 21.3006C26.6095 21.1971 27.8219 20.7641 28.8637 20.0449C29.839 19.3877 30.0901 17.5628 30.0399 16.2778C30.0526 15.7333 29.9528 15.1921 29.7468 14.688C29.5408 14.1838 29.2331 13.7276 28.8428 13.3478C27.8759 12.406 26.9592 12.3181 25.9672 12.1507C24.9752 11.9833 21.363 12.3558 21.363 12.3558L21.5388 14.051C22.1666 13.9715 25.1468 13.3855 26.6537 13.9547C28.1605 14.524 28.5414 15.3946 28.374 17.3033C28.2442 18.7766 26.4821 19.35 25.218 19.4463L21.9783 19.6975L22.0955 21.5475Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.761 9.36719C22.761 9.36719 23.3135 14.0593 23.4433 15.7587C23.5731 17.4581 23.6777 19.4965 23.6986 20.363C23.6986 21.0494 24.0586 23.1632 23.8409 23.5231C23.6233 23.8831 21.8779 25.2811 17.441 25.3774C13.0042 25.4737 11.8657 25.1681 11.6188 24.5026C11.3718 23.8371 11.3006 20.3169 11.0621 17.2279L10.5347 10.3006L22.761 9.36719Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.843 10.8551C20.2296 10.5842 22.9366 9.88484 22.8893 9.29305C22.842 8.70126 20.0582 8.44115 16.6716 8.71208C13.2849 8.983 10.5779 9.68238 10.6253 10.2742C10.6726 10.866 13.4564 11.1261 16.843 10.8551Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5144 10.899C11.874 10.6269 14.9673 10.0619 15.9927 9.98652C17.0182 9.91118 18.9562 9.72701 19.6594 9.88606C20.1072 9.99775 20.5476 10.1376 20.9779 10.3046C20.1899 10.5054 19.3903 10.6578 18.5837 10.7609C17.8428 10.7944 13.2344 11.2087 12.5144 10.899Z"
                    fill="#2D2D2D"
                />
                <path
                    d="M17.9499 6.15326C18.1649 5.94417 18.3045 5.66972 18.3469 5.37284C18.3894 5.07596 18.3322 4.77339 18.1843 4.51247C17.8927 4.05226 17.6566 3.55909 17.4811 3.0433C17.4598 2.58727 17.609 2.13964 17.8997 1.7876"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.5197 6.03191C19.7372 5.75078 19.8716 5.4144 19.9079 5.06082C19.9441 4.70724 19.8807 4.35057 19.7248 4.03116C19.4209 3.45777 19.1769 2.85465 18.9965 2.23132C18.9511 1.68622 19.0881 1.1415 19.3857 0.682617"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11310">
                    <rect width="30" height="30" fill="white" transform="translate(0.976562 0.287109)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFBeveragesInactive;

IFBeveragesInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFBeveragesInactive.defaultProps = {
    className: null,
};
